// import { takeEvery } from 'redux-saga/effects'
// import { brands as actions } from 'flux/actions'
// import { brands as api } from 'flux/api'

export default function* () {
  // yield takeEvery(actions.types.SOMETHING, doSomething)
}
